export * from './welcome-ok.component';
export * from './welcome-ok.model';